import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_TEMPLATES',
    icon: 'TypeIcon',
    action: constants.action.permissionLogin,
    resource: constants.resource.user,
    children: [
      {
        title: 'DEBTIA_EMAIL_TEMPLATE',
        route: 'email-templates',
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
      {
        title: 'DEBTIA_SMS_TEMPLATE',
        route: 'sms-templates',
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    ],
  },
]
